import { redirectTo } from './redirect-to';
import { environment } from 'utils/environment.utils';
import { credentialsRepository } from 'data/repositories/credential.repository';

export const checkAuth = (): void => {
    try {
        const credentials = credentialsRepository.getCredentials();
        if (!credentials) throw Error('unauthenticated');
    } catch ({ message }) {
        redirectTo(environment.URLS.APP_LOGIN);
    }
};
